enum EnvironmentsEnum {
  Production = 'production',
  Development = 'development',
  Staging = 'staging',
}
export default EnvironmentsEnum;
